import React from "react";
import { Box, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    "& > button": {
      padding: theme.spacing(0.25, 1)
    }
  },
  item: {
    minWidth: "unset",
    fontWeight: "unset"
  },
  selected: {
    fontWeight: "bold",
    background: theme.palette.body
  }
}));

const AlphabetFilter = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const allLettersLabel = t("all");
  const filterOptions = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const filterLabels = [allLettersLabel].concat(filterOptions);
  return (
    <Box display="flex" justifyContent="space-between" className={classes.root}>
      {filterLabels.map((label, index) => (
        <Button
          key={index}
          color="primary"
          className={clsx(classes.item, {
            [classes.selected]:
              props.value === label.toLowerCase() ||
              (label === allLettersLabel && !props.value)
          })}
          onClick={() =>
            props.onChange(label === allLettersLabel ? "" : label.toLowerCase())
          }
        >
          {label}
        </Button>
      ))}
    </Box>
  );
};

AlphabetFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

AlphabetFilter.defaultProps = {
  value: ""
};

export default AlphabetFilter;
